import React, { useState, ChangeEvent } from 'react';
import { connect } from 'react-redux';
import SubHeader from 'components/general/SubHeader/SubHeader';
import Radio from 'components/forms/Radio';
import fetchData, { fetchDataResponse } from 'utils/fetchData';
import FileSaver from 'file-saver';
import getAccessToken from 'selectors/getAccessToken';

const getAuthToken = (state: any): string | undefined => {
  const rawToken = getAccessToken(state);
  return typeof rawToken === 'string' && rawToken.length > 0
    ? rawToken
    : undefined;
};

const mapStateToProps = (state: any) => ({
  auth: getAuthToken(state),
});

interface MetricsDownloadProps {
  auth?: string;
}

const MetricsDownload: React.FC<MetricsDownloadProps> = ({ auth }) => {
  const [period, setPeriod] = useState('month');
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);

    try {
      const resp = await fetchData('GET', 'metrics/email/outbound', {
        auth,
        headers: {
          "Content-Type": "text/csv",
        },
        query: {
          "frequency": period,
        }
      }) as fetchDataResponse;

      if (resp.data) {
        const time = new Date();
        const filename = `GSI_Outbound_Email_Metrics_${String(period).charAt(0).toUpperCase() + String(period).slice(1)}_${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()}_${time.getHours()}-${time.getMinutes()}-${time.getSeconds()}.csv`;
        FileSaver.saveAs(new Blob([resp.data as BlobPart], { type: 'text/csv;charset=UTF-8' }), filename);
      }
    } catch (error: any) {
      console.error('Error downloading metrics:', error);
    } finally {
      setDownloading(false);
    }
  };

  const handlePeriodChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPeriod(e.target.value);
  };

  return (
    <>
      <SubHeader
        title="Outbound Email Metrics"
        summary="Download the outbound email statistics to CSV format."
      />
      <div className="form-field">
        <div className="form-field__label">
          <span className="form-field__label-contents">
            Group by
          </span>
        </div>
        <div className="form-field__control">
          <div className="multiple-choice-inline-group">
            <Radio
              name="period"
              value="day"
              label="Day"
              checked={period === 'day'}
              onChange={handlePeriodChange}
            />
            <Radio
              name="period"
              value="month"
              label="Month"
              checked={period === 'month'}
              onChange={handlePeriodChange}
            />
            <Radio
              name="period"
              value="year"
              label="Year"
              checked={period === 'year'}
              onChange={handlePeriodChange}
            />
          </div>
        </div>
      </div>
      <div style={{ marginTop: '2rem' }}>
        <button
          className="btn btn--accent"
          onClick={handleDownload}
          disabled={downloading}
        >
          Download
        </button>
      </div>
    </>
  );
};

export default connect(mapStateToProps)(MetricsDownload);
